import type { EntityId } from '@pkg/db/schema'
import * as uuid from 'uuid'

export const generateUuid = () => {
  return uuid.v4().replaceAll('-', '')
}

export const generateEntityUuid = <E extends string = string>(entity: E): EntityId<E> => {
  return `${entity}_${generateUuid()}`
}
